export default "/images/6810cb384251a0c253f52dd6dca4412e.png";